<script>
    export default {
        props: {
            value: {
                required: true
            },
            field: {
                type: String,
                required: true
            },
            tag: {
                type: String,
                default: 'td'
            }
        },

        render(renderer) {
            const classes = {
                'order-tag': true
            };

            const parts = this.value.split(',');

            if (this.field === parts[0]) {
                classes['order-active'] = true;
                classes[`order-${parts[1]}`] = true;
            }

            return renderer(
                this.tag,
                {
                    class: classes,
                    on: {
                        click: this.onClick
                    }
                },
                this.$slots.default
            );
        },

        methods: {
            onClick() {
                const value = {
                    field: '',
                    direction: ''
                };

                const parts = this.value.split(',');

                if (this.field === parts[0]) {
                    if (parts[1] === 'asc') {
                        value.direction = 'desc';
                    } else if (parts[1] === 'desc') {
                        value.direction = 'asc';
                        value.field = '';

                        this.$emit('input', `${value.field},${value.direction}`);
                        this.$emit('change', `${value.field},${value.direction}`);

                        return;
                    }
                } else {
                    value.direction = 'asc';
                }

                value.field = this.field;

                this.$emit('input', `${value.field},${value.direction}`);
                this.$emit('change', `${value.field},${value.direction}`);
            }
        }
    };
</script>

<style>
    .order-tag {
        cursor: pointer;
    }

    .order-tag:after {
        content: "";
        margin-left: 5px;
        position: absolute;
        margin-top: 4px;
        background-image: url('../../../images/icons/sorting.svg');
        background-size: cover;
        width: 10px;
        height: 11px;
    }

    .order-tag.order-active.order-asc:after {
        background-image: url('../../../images/icons/sorting-asc.svg');
    }

    .order-tag.order-active.order-desc:after {
        background-image: url('../../../images/icons/sorting-desc.svg');
    }
</style>
